/* eslint-disable @typescript-eslint/no-explicit-any */
// ** React Imports
import { Fragment, useEffect, memo } from "react";

// ** Third Party Components
import classnames from "classnames";

// ** Redux
import { useSelector } from "react-redux";
import { useAppDispatch } from "@src/redux/hooks";

// ** ThemeConfig
import themeConfig from "@configs/themeConfig";

// ** Styles
import "animate.css/animate.css";

// ** Actions
import {
  handleContentWidth,
  handleMenuCollapsed,
  handleMenuHidden,
} from "@src/redux/layout";

// ** LayoutWrapper Component
const LayoutWrapper = (props: any) => {
  const { children, routeMeta } = props;

  const dispatch = useAppDispatch();

  // Select specific pieces of state (✅ no more root state)
  const layout = useSelector((state: any) => state.layout.layout);
  const contentWidth = useSelector((state: any) => state.layout.contentWidth);
  const menuCollapsed = useSelector((state: any) => state.layout.menuCollapsed);
  const menuHidden = useSelector((state: any) => state.layout.menuHidden);
  const navbarQuery = useSelector((state: any) => state.navbar.query);

  // Determine tag conditionally
  const appLayoutCondition =
    (layout === "horizontal" && !routeMeta) ||
    (layout === "horizontal" && routeMeta && !routeMeta.appLayout);

  const Tag = appLayoutCondition ? "div" : Fragment;

  // ** Cleanup on unmount
  const cleanUp = () => {
    if (routeMeta) {
      if (routeMeta.contentWidth && routeMeta.contentWidth === contentWidth) {
        dispatch(handleContentWidth(themeConfig.layout.contentWidth));
      }
      if (routeMeta.menuCollapsed && routeMeta.menuCollapsed === menuCollapsed) {
        dispatch(handleMenuCollapsed(!menuCollapsed));
      }
      if (routeMeta.menuHidden && routeMeta.menuHidden === menuHidden) {
        dispatch(handleMenuHidden(!menuHidden));
      }
    }
  };

  // ** useEffect for handling route meta
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth && routeMeta.contentWidth !== contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth));
      }
      if (routeMeta.menuCollapsed && routeMeta.menuCollapsed !== menuCollapsed) {
        dispatch(handleMenuCollapsed(routeMeta.menuCollapsed));
      }
      if (routeMeta.menuHidden && routeMeta.menuHidden !== menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden));
      }
    }
    return () => cleanUp();
  }, [routeMeta]);

  return (
    <div
      className={classnames("app-content content overflow-hidden", {
        [routeMeta?.className || ""]: !!routeMeta?.className,
        "show-overlay": navbarQuery.length,
      })}
    >
      <div className="content-overlay"></div>
      <div className="header-navbar-shadow" />
      <div
        className={classnames({
          "content-wrapper": routeMeta && !routeMeta.appLayout,
          "content-area-wrapper": routeMeta?.appLayout,
          "container-xxl p-0": contentWidth === "boxed",
        })}
      >
        <Tag {...(appLayoutCondition ? { className: "content-body" } : {})}>
          {children}
        </Tag>
      </div>
    </div>
  );
};

export default memo(LayoutWrapper);
